/* eslint-disable react/prop-types */
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSetRecoilState } from 'recoil';
import { useIntl } from 'react-intl';
import { arrayChangesAtom, enableChangesAtom, openProjectNameAtom } from '../Atoms';

const ConfirmExitDialog = function ConfirmExitDialog({ open, close }) {
  const setOpenProjectName = useSetRecoilState(openProjectNameAtom);
  const setEnableChanges = useSetRecoilState(enableChangesAtom);
  const setArrayChanges = useSetRecoilState(arrayChangesAtom);
  const intl = useIntl();
  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle id="title">{intl.messages.EXITCONF_TITLE}</DialogTitle>
      <DialogContent>
        <DialogContentText id="description">{intl.messages.EXITCONF_TXT}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>{intl.messages.DISCARD}</Button>
        <Button
          onClick={() => {
            close();
            setOpenProjectName(null);
            setEnableChanges(false);
            setArrayChanges([]);
          }}
          autoFocus
        >
          {intl.messages.CONFIRMCHANGES}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmExitDialog;
